import { IconName } from '@aibees/shared/components';
import { Maybe } from '@aibees/shared/definition';

export enum BuyingTeamType {
  DEPARTMENT = 'DEPARTMENT',
  BUYING_TEAM = 'BUYING_TEAM',
}

export enum JobFuntionsType {
  ALL_DEPARTMENTS = 'all',
}

export type BuyingTeamItem = {
  index: string;
  value: Record<string, Maybe<string>>;
  label: string;
  key: string;
  icon: IconName;
  type?: BuyingTeamType;
};

export interface BuyingTeamTabsProps {
  className?: string;
  defaultValue?: string;
  items?: BuyingTeamItem[];
  onChange: (value: string) => void;
}
